var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetalleDePlanSucursales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.1DetalleDePlan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MANAGER",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.2-Clientes",
    transform: "translate(-832.000000, -670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(808.620075, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(23.379925, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1DetalleDePlan",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "1.1-DashboardLateralOFF",
    transform: "translate(9.600000, 8.700000)",
    stroke: "#FE8D27",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5.6,
    y: 10.4,
    width: 4.8,
    height: 6.4,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.07628992 L15.2,7.55628992 L15.2,16 C15.2,16.2666667 15.1752734,16.4933558 15.0343146,16.6343146 C14.8933558,16.7752734 14.6666667,16.8 14.4,16.8 L14.4,16.8 L1.6,16.8 C1.33333333,16.8 1.10664422,16.7752734 0.965685425,16.6343146 C0.82472663,16.4933558 0.8,16.2666667 0.8,16 L0.8,16 L0.8,7.55628992 L8,1.07628992 Z",
    id: "Path-6"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalleDePlanSucursales);
export default __webpack_public_path__ + "static/media/DetalleDePlanSucursales.c7ff3cf3159df84c10e256f392c5c59f.svg";
export { ForwardRef as ReactComponent };